import React from 'react';

const Navbar = () => {
  return <nav>Job Application Tracker</nav>;
};

export default Navbar;